var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHalfNoteActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FFF4DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9906 4H18.3994V19.9114C18.1789 19.6814 17.8926 19.4984 17.5689 19.3811C17.1184 19.2075 16.621 19.1325 16.1284 19.1278C15.1336 19.1184 14.1529 19.3999 13.313 19.8551C12.4731 20.3149 11.774 20.9953 11.3798 21.7836C10.9904 22.5531 10.8027 23.4822 11.3 24.2188C11.8068 24.9461 12.8438 25.2324 13.801 25.2558C14.7817 25.284 15.7764 25.0259 16.6163 24.5708C17.4516 24.1109 18.1789 23.4587 18.6059 22.6704C18.817 22.2763 18.9625 21.8539 18.9906 21.4223C18.9953 21.3706 18.9906 21.3237 18.9906 21.2721L19 21.2909V4H18.9906ZM17.9255 22.3326C17.4046 22.905 16.7477 23.3695 16.0439 23.7543C15.3354 24.1344 14.5846 24.4722 13.7635 24.6364C13.3552 24.7162 12.9282 24.7397 12.5247 24.6599C12.1259 24.5801 11.7552 24.3831 11.5393 24.0828C11.3235 23.7825 11.2719 23.3977 11.3751 23.0458C11.469 22.6892 11.6942 22.3607 11.957 22.0745C12.5059 21.502 13.191 21.0703 13.8902 20.6856C14.594 20.3055 15.3588 19.9958 16.1659 19.8457C16.9542 19.6908 17.8786 19.7659 18.39 20.3477C18.7888 21.0093 18.4229 21.7836 17.9208 22.3372L17.9255 22.3326Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfNoteActive);
export default __webpack_public_path__ + "static/media/half-note-active.4d23980bbce183c62ada1eea7352d193.svg";
export { ForwardRef as ReactComponent };